import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';

declare const mixpanel: any;

@Injectable({
    'providedIn': 'root'
})
export class MixpanelService {

    public setUser(user: any): void {
        if (this.isNotAdmin(user)) {
            if (this.isProductionEnvironment()) {
                mixpanel.identify(user.id);
                mixpanel.people.set(this.getUserData(user));
            } else {
                console.log('Setting mixpanel user', this.getUserData(user));
            }
        }
    }

    public trackProposalCreation(type: 'retailer' | 'manufacturer') {
        if (this.isProductionEnvironment()) {
            mixpanel.track("Proposal", {
                "from": type
            });
        } else {
            console.log('Tracking Proposal creation for ' + type);
        }
    }

    private isProductionEnvironment(): boolean {
        return environment.production && !window.location.hostname.startsWith('qa-pricing');
    }

    private getUserData(user: any) {
        return {
            "$email": user.email,
            "Sign up date": user.created_at.split(' ').join('T') + 'Z',    // Send dates in ISO timestamp format (e.g. "2020-01-02T21:07:03Z")
            "USER_ID": user.id,
            "plan": user.pricing_plan ? user.pricing_plan.chargebee_plan_id : null
        };
    }

    private isNotAdmin(user: any): boolean {
        return user.showroom_id || user.vendor_id;
    }
}